<template>
  <div class="userprofile-page">
    <h1 class="userprofile-title">
      Thông tin khách hàng
    </h1>
    <div class="userprofile-content shadow-md">
      <p class="userprofile-subtitle mb-6">
        Thông tin chung
      </p>
      <div class="flex flex-wrap flex-col lg:flex-row -mx-2" >
        <div class="w-full lg:w-1/2 px-3">
          <p class="userprofile-label">Họ và tên</p>
          <p class="userprofile-value">
            {{$store.state.user.currentUser.FullName}}
          </p>
          <hr class="my-6" />
        </div>
        <div class="w-full lg:w-1/2 px-3">
          <p class="userprofile-label">Giới tính</p>
          <p class="userprofile-value" v-if="gender">{{gender}}</p>
          <p class="userprofile-value" v-else>N/A</p>
          <hr class="my-6" />
        </div>
        <div class="w-full lg:w-1/2 px-3">
          <p class="userprofile-label">Ngày sinh </p>
          <p class="userprofile-value" v-if="$store.state.user.currentUser.DateOfBbirth">
            {{ $store.state.user.currentUser.DateOfBbirth | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
          </p>
          <p class="userprofile-value" v-else>
            N/A
          </p>
          <hr class="my-6" />
        </div>
        <div class="w-full lg:w-1/2 px-3">
          <div class="userprofile-label-wrapper"><p class="userprofile-label">Email</p><div class="userprofile-edit-action" @click="openUpdateEmailForm">Chỉnh sửa</div></div>
          <p class="userprofile-value" >
            {{$store.state.user.currentUser.Email}}
          </p>
          <hr class="my-6" />
        </div>
        <div class="w-full lg:w-1/2 px-3">
          <p class="userprofile-label">Số CMND</p>
          <p class="userprofile-value">
            {{idNumber}}
          </p>
          <hr class="my-6" />
        </div>
        <div class="w-full lg:w-1/2 px-3">
          <p class="userprofile-label">Điện thoại phụ</p>
          <p class="userprofile-value" v-if="$store.state.user.currentUser.OtherPhoneNumber">{{$store.state.user.currentUser.OtherPhoneNumber}}</p>
          <p class="userprofile-value" v-else>N/A</p>
          <hr class="my-6" />
        </div>
        <div class="w-full lg:w-1/2 px-3">
          <div class="userprofile-label-wrapper"><p class="userprofile-label">Điện thoại chính</p><div class="userprofile-edit-action" @click="openUpdatePhoneNumberForm">Chỉnh sửa</div></div>
          <p class="userprofile-value">
            {{$store.state.user.currentUser.Phone}}
          </p>
          <hr class="my-6" />
        </div>
        <div class="w-full lg:w-1/2 px-3">
          <div class="userprofile-label-wrapper"><p class="userprofile-label">Địa chỉ liên lạc</p><div class="userprofile-edit-action" @click="openUpdateAddressForm">Chỉnh sửa</div></div>
          <p class="userprofile-value" v-if="$store.state.user.currentUser.AddressList">
            {{contactAddress}}
          </p>
          <p class="userprofile-value" v-else @click="openUpdateAddressForm">
            N/A
          </p>
          <!-- Notice: change last one to mt -->
          <hr class="mt-6" />
        </div>
        <div class="w-full px-3 text-center">
          <router-link class="primary-button userprofile-history-action" :to="{ name: 'profileHistory' }" >LỊCH SỬ CHỈNH SỬA</router-link>
        </div>
      </div>
    </div>
    <div class="userprofile-content shadow-md">
      <!-- Notice: mb-6 -> mb-0 when edit password -->
      <p class="userprofile-subtitle mb-6">
        Mật khẩu
      </p>
      <!-- Notice: remove this one when edit password -->
      <div
        class="flex flex-wrap flex-col lg:flex-row -mx-2"
        v-show="!showForm"
      >
        <div class="w-full lg:w-1/2 px-3">
          <p class="userprofile-label">
            Mật khẩu
          </p>
          <p class="userprofile-value">
            ***********
          </p>
          <hr class="mt-6" />
          <div class="userprofile-edit" @click="openEdit">
            Chỉnh sửa
          </div>
        </div>
      </div>
      <div
        class="userprofile-form flex flex-col -mx-3"
        v-show="showForm"
      >
        <div class="w-full lg:w-1/2 px-3">
          <p class="password-hint">
            * Mật khẩu bao gồm: Chữ hoa và
            thường, số, ký tự đặc biệt, tối
            thiểu 12 ký tự.
          </p>
        </div>
        <div class="w-full lg:w-1/2 px-3">
            <div class="mb-4">
              <label
                class="block userprofile-label"
              >
                Mật khẩu hiện tại
              </label>
              <input
                ref="oldPassword"
                class="profile-input"
                type="password"
                placeholder="Mật khẩu hiện tại"
                v-model="oldPassword"
              />
              <p
                :class="[ errorOldPassword ? 'block' : 'hidden' ]"
                class="text-red-400 text-error mb-4"
              >
                {{errorOldPassword}}
              </p>
              <p
                :class="[ (submitted && $v.oldPassword.$error && !$v.oldPassword.required) ? 'block' : 'hidden' ]"
                class="text-red-400 text-error mb-4"
              >
                Vui lòng nhập mật khẩu hiện tại
              </p>
            </div>
            <div class="mb-4">
              <label
                class="block userprofile-label"
              >
                Mật khẩu mới
              </label>
              <input
                class="profile-input"
                type="password"
                placeholder="Mật khẩu mới"
                v-model="password"
              />
              <p
                :class="[ submitted && $v.password.$error && !$v.password.required ? 'block' : 'hidden' ]"
                class="text-red-400 text-error mb-4"
              >
                Mật khẩu mới không được để trống
              </p>
              <p
                :class="[ submitted && $v.password.$error && !$v.password.complex ? 'block' : 'hidden' ]"
                class="text-red-400 text-error mb-4"
              >
                Mật khẩu không đúng định dạng
              </p>
            </div>
            <div class="mb-4">
              <label
                class="block userprofile-label"
              >
                Nhập lại mật khẩu mới
              </label>
              <input
                class="profile-input"
                type="password"
                placeholder="Nhập lại mật khẩu mới"
                v-model="confirmPassword"
              />
              <p
                :class="[ submitted && $v.confirmPassword.$error && !$v.confirmPassword.required ? 'block' : 'hidden' ]"
                class="text-red-400 text-error mb-4"
              >
                Vui lòng nhập xác nhận mật khẩu
              </p>
              <p
                :class="[ submitted && $v.confirmPassword.$error && !$v.confirmPassword.sameAsPassword ? 'block' : 'hidden' ]"
                class="text-red-400 text-error mb-4"
              >
                Mật khẩu nhập lại không trùng
              </p>
            </div>
            <div
              class="flex items-center justify-between -mx-4"
            >
              <div
                class="w-full lg:w-1/2 px-4"
              >
                <button
                  class="userprofile-button w-full"
                  type="button"
                  @click="cancelEdit"
                >
                  huỷ
                </button>
              </div>
              <div
                class="w-full lg:w-1/2 px-4"
              >
                <button
                  class="userprofile-button active w-full"
                  type="button"
                  @click="openVerifyOTP"
                >
                  <vue-element-loading :active="isRequest"/>
                  cập nhật
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="userprofile-content shadow-md">
      <!-- Notice: mb-6 -> mb-0 when edit password -->
      <p class="userprofile-subtitle mb-6">
          Thông báo
      </p>
      <!-- Notice: remove this one when edit password -->
      <div
        class="flex flex-wrap flex-row -mx-2"
      >
        <div class="w-full lg:w-1/2 px-3 mb-3 lg:mb-0">
          <p class="userprofile-value">
            Tôi muốn nhận email nhắc nợ hàng tháng
          </p>
          <p style="color: #4a4a4a;font-size: 14px;font-weight: 400;letter-spacing: 0.5px;line-height: 28px;margin-bottom: 0;">
            (Quý khách vui lòng cập nhật email để nhận email nhắc nợ hàng tháng)
          </p>
        </div>
        <div class="w-full lg:w-1/2 px-3 text-left text-right">
            <ToggleButton labelEnableText="Có" labelDisableText="Không" @change="updateViaEmail" :defaultState="$store.state.user.currentUser.IsViaEmail === 0 ? true : false"></ToggleButton>
        </div>
      </div>
    </div>
    <UiModal closeOnOverlay :show.sync="showOTPForm">
      <div class="modal-container bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50 overflow-y-auto modal-otp">
        <div class="modal-content text-center">
      <!--Body-->
      <p class="modal-otp-title">Xác nhận mật mã OTP</p>
      <div class="mb-4 form-controls">
        <label
          class="block text-sm font-bold mb-2"
        >
          Nhập mã OTP bạn vừa nhận
        </label>
        <div class="digit-group">
              <OTPInput
                ref="otpInput"
                :isDisabled="false"
                :isError="false"
                :onChangeOTP="onChangeOTP"
                :shouldResetOTP="true"
                :numberOfInput="6"
              />
              <p
                :class="[ errorOTP !== '' ? 'block' : 'hidden' ]"
                class="text-red-400 text-error mb-4"
              >
                {{errorOTP}}
              </p>
        </div>
      </div>
      <div>
        <button
          class="submit-button block mt-8 w-full mb-2 bg-red-500 hover:bg-red-400 text-white font-bold py-2 px-4 border-red-700 hover:border-red-500 rounded"
          @click="updatePassword"
          :disabled="isRequest"
        >
          <vue-element-loading :active="isRequest"/>
          Tiếp tục
        </button>
        <div class="text-center underline">
          <a href="#" @click="requestResendOtp">
            <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
              <template slot-scope="props">Vui lòng thử lại sau {{ props.totalSeconds }} giây</template>
            </countdown>
            <span v-else>Gửi lại mã OTP</span>
          </a>
        </div>
      </div>
        </div>
      </div>
    </UiModal>

    <!-- UPDATE MAIL FORM -->
    <UiModal closeOnOverlay :show.sync="showUpdateEmailForm">
      <div class="update-email-form-modal">
        <div class="update-email-form-modal-close" @click="showUpdateEmailForm = false"><img src="@/assets/img/icon-close.svg" alt="Close" /></div>
        <update-email-form v-on:closeForm="showUpdateEmailForm = false"></update-email-form>
      </div>
    </UiModal>
    <!-- END UPDATE MAIL FORM -->

    <!-- UPDATE NEW PHONE NUMBER FORM -->
    <UiModal closeOnOverlay :show.sync="showUpdatePhoneNumberForm">
      <div class="update-email-form-modal">
        <div class="update-email-form-modal-close" @click="showUpdatePhoneNumberForm = false"><img src="@/assets/img/icon-close.svg" alt="Close" /></div>
        <update-phone-form v-on:closeForm="showUpdatePhoneNumberForm = false"></update-phone-form>
      </div>
    </UiModal>
    <!-- END UPDATE NEW PHONE NUMBER FORM -->

    <!-- UPDATE ADRESS FORM -->
    <UiModal closeOnOverlay :show.sync="showUpdateAddressForm">
      <div class="update-email-form-modal">
        <div class="update-email-form-modal-close" @click="showUpdateAddressForm = false"><img src="@/assets/img/icon-close.svg" alt="Close" /></div>
        <update-address-form v-on:closeForm="showUpdateAddressForm = false"></update-address-form>
      </div>
    </UiModal>
    <!-- END UPDATE ADRESS FORM -->
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, sameAs, email } from 'vuelidate/lib/validators'
import { UsersService } from '@/services/users.service'
import UiModal from '@/components/UiModal.vue'
import OTPInput from '@/components/OTPInput.vue'
import { AuthService } from '@/services/auth.service'
import Countdown from '@/components/Countdown'
import UpdateEmailForm from '@/pages/profile/misc/UpdateEmailForm'
import UpdateAddressForm from '@/pages/profile/misc/UpdateAddressForm'
import UpdatePhoneForm from '@/pages/profile/misc/UpdatePhoneForm'
import ToggleButton from '@/components/ToggleButton'

const complex = (value) => {
  // eslint-disable-next-line no-useless-escape
  const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})')
  return strongRegex.test(value)
}

export default {
  name: 'PersonalPage',
  mixins: [validationMixin],
  components: {
    ToggleButton,
    UpdatePhoneForm,
    UpdateEmailForm,
    UpdateAddressForm,
    UiModal,
    OTPInput,
    Countdown
  },
  data () {
    return {
      showForm: false,
      oldPassword: '',
      password: '',
      confirmPassword: '',
      errorOldPassword: false,
      submitted: false,
      submittedEmail: false,
      showOTPForm: false,
      otp: '',
      errorOTP: '',
      successOTP: '',
      isRequest: false,
      username: localStorage.getItem('username'),
      counting: false,
      newEmail: '',
      showUpdateEmailForm: false,
      showUpdatePhoneNumberForm: false,
      showUpdateAddressForm: false
    }
  },
  validations: {
    oldPassword: { required },
    password: { required, complex },
    confirmPassword: { required, sameAsPassword: sameAs('password') },
    newEmail: { required, email }
  },
  computed: {
    contactAddress () {
      const mailtagAdd = this.$store.state.user.currentUser.AddressList.find((o) => {
        return o.AddrCdPortal === 'MAILTAGADD'
      })
      return mailtagAdd.Address + ' ' + mailtagAdd.WardName + ', ' + mailtagAdd.DistrictName + ', ' + mailtagAdd.CityName
    },
    gender () {
      switch (this.$store.state.user.currentUser.Gender) {
        case 'M':
          return 'Nam'
        case 'F':
          return 'Nữ'
        default:
          return ''
      }
    },
    idNumber () {
      return this.$store.state.user.currentUser.IdentityCard.replace(/^.{1,5}/, m => '*'.repeat(m.length))
    }
  },
  methods: {
    openEdit: function () {
      this.showForm = true
      this.$nextTick(() => {
        this.$refs.oldPassword.focus()
      })
    },
    cancelEdit: function () {
      this.showForm = false
      this.error = false
    },
    onChangeOTP (otp) {
      this.otp = otp
    },
    openVerifyOTP () {
      this.submitted = true
      this.$v.oldPassword.$touch()
      this.$v.password.$touch()
      this.$v.confirmPassword.$touch()
      if (this.$v.oldPassword.$invalid || this.$v.password.$invalid || this.$v.confirmPassword.$invalid) {
        return
      }
      this.isRequest = true
      this.errorOldPassword = ''
      AuthService.resendOTP({
        username: this.username,
        password: this.oldPassword
      }).then(response => {
        if (response.data.data.IsResult === false) {
          this.isRequest = false
          this.errorOldPassword = 'Mật khẩu cũ không đúng'
          return
        }
        this.isRequest = false
        this.errorOldPassword = ''
        this.showOTPForm = true
        this.$nextTick(() => {
          this.$refs.otpInput.focusFirstInput()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    requestUpdateEmail () {
      this.$v.newEmail.$touch()
      if (this.$v.newEmail.$invalid) {
        return
      }
      this.submittedEmail = true
    },
    updatePassword: function () {
      this.isRequest = true
      AuthService.verifyOtp({
        username: this.username,
        password: this.oldPassword,
        otp: this.otp,
        isloginpage: false
      }).then(response => {
        if (response.data.data.IsResult === false) {
          this.errorOTP = response.data.Message
          this.isRequest = false
          return
        }
        this.errorOTP = ''
        UsersService.changePassword(this.oldPassword, this.password).then(response => {
          if (response.data.data.IsResult === false) {
            this.$store.commit('toast/NEW', { type: 'error', message: response.data.Message })
            this.showOTPForm = false
            this.isRequest = false
            this.cancelEdit()
            return
          }
          this.$store.commit('toast/NEW', { type: 'success', message: 'Mật khẩu đã cập nhật thành công' })
          this.showOTPForm = false
          this.isRequest = false
          this.cancelEdit()
        }).catch(error => console.log(error))
      }).catch((error) => {
        this.isRequest = false
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    requestResendOtp () {
      if (this.counting === true) return
      this.counting = true
      AuthService.resendOTP({
        username: this.username,
        password: this.oldPassword
      }).then(response => {
        if (response.data.data.IsResult === false) {
          this.errorOTP = response.data.Message
          return
        }
        this.errorOTP = ''
        this.success = response.data.Message // response.data.Message
      }).catch((error) => {
        console.log(error)
      })
    },
    handleCountdownEnd: function () {
      this.counting = false
    },
    openUpdateEmailForm: function () {
      this.showUpdateEmailForm = true
    },
    openUpdatePhoneNumberForm: function () {
      this.showUpdatePhoneNumberForm = true
    },
    openUpdateAddressForm: function () {
      this.showUpdateAddressForm = true
    },
    updateViaEmail: function (val) {
      const status = val === true ? 0 : 1
      UsersService.updateViaEmail(status)
    }
  }
}
</script>
<style lang="scss">
  @import '@/scss/components/_updateEmailForm.scss';
  @import '@/scss/components/_profileEdit.scss';
</style>
